import axios from "axios";

export const getRegions = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get(`/clients/regions`, params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getRegion = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/clients/regions/${data.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createRegion = async ({ data, create }: any) => {
	try {
		const res: any = await axios.post(`/clients/regions/`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const updateRegion = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/clients/regions/${data.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const deleteRegion = async ({ data }: any) => {
	try {
		const res: any = await axios.delete(`/clients/regions/${data.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};
